export interface IUrlFilterItem {
  filters?: string
}

export interface IUrlFilters {
  filterParams?: {
    [key: string]: IUrlFilterItem
  }
}
